var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuidelineBackground1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 159.009,
    height: 131.823,
    viewBox: "0 0 159.009 131.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154545",
    "data-name": "Rectangle 154545",
    width: 51.328,
    height: 51.086,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154560",
    "data-name": "Rectangle 154560",
    width: 79.137,
    height: 47.383,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154542",
    "data-name": "Rectangle 154542",
    width: 56.727,
    height: 79.061,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_187645",
    "data-name": "Group 187645",
    transform: "translate(5113.719 -1149.16)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187597",
    "data-name": "Group 187597",
    transform: "translate(-5091.913 1149.16)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187596",
    "data-name": "Group 187596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187595",
    "data-name": "Group 187595",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38320",
    "data-name": "Path 38320",
    d: "M697.266,350.438a3.2,3.2,0,1,0,2.123-.921l-.984-2.453a18.321,18.321,0,0,1-2.146.862Z",
    transform: "translate(-664.885 -304.811)",
    fill: "#b697c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38321",
    "data-name": "Path 38321",
    d: "M718.7,294.862l2.507-1.053a3.207,3.207,0,1,0-.954-2.108l-2.453,1.03c.176.352.344.71.5,1.075.146.346.277.7.4,1.056",
    transform: "translate(-675.686 -275.368)",
    fill: "#b697c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38322",
    "data-name": "Path 38322",
    d: "M666.643,270.474l-.985-2.453a3.2,3.2,0,1,0-2.146.862l.986,2.456c.486-.232.983-.446,1.492-.636q.323-.12.653-.228",
    transform: "translate(-646.851 -262.416)",
    fill: "#b697c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38323",
    "data-name": "Path 38323",
    d: "M641.735,325.763l-2.429,1.02a3.2,3.2,0,1,0,.9,2.132l2.428-1.02c-.169-.34-.33-.683-.477-1.034s-.288-.728-.417-1.1",
    transform: "translate(-633.584 -294.132)",
    fill: "#b697c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38324",
    "data-name": "Path 38324",
    d: "M727.041,323.165a3.187,3.187,0,0,0-5.336-.781l-2.48-.953c.127-.414.243-.832.341-1.258a2.386,2.386,0,0,1,1.965-1.8,2.386,2.386,0,0,0-1.965,1.8,18.344,18.344,0,0,1-.642,2.167q-.129.352-.271.7c-.078.189-.161.375-.244.56l2.526.97a3.192,3.192,0,1,0,6.106-1.4",
    transform: "translate(-675.99 -290.425)",
    fill: "#df98c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38325",
    "data-name": "Path 38325",
    d: "M663.561,349.452a3.2,3.2,0,1,0,2.169.8l.954-2.37a18.251,18.251,0,0,1-2.144-.867Z",
    transform: "translate(-646.92 -304.789)",
    fill: "#df98c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38326",
    "data-name": "Path 38326",
    d: "M657.776,347.168a2.426,2.426,0,0,1-.368.3,2.426,2.426,0,0,0,.368-.3",
    transform: "translate(-645.409 -304.863)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38327",
    "data-name": "Path 38327",
    d: "M655.025,348.523a2.339,2.339,0,0,1-.27.026,2.339,2.339,0,0,0,.27-.026",
    transform: "translate(-644.079 -305.542)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38328",
    "data-name": "Path 38328",
    d: "M718.8,281.24a2.393,2.393,0,0,1,.3,1.123,2.393,2.393,0,0,0-.3-1.123",
    transform: "translate(-676.185 -271.812)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38329",
    "data-name": "Path 38329",
    d: "M729.391,309.268c.068.037.141.068.206.111a2.324,2.324,0,0,0-.206-.111",
    transform: "translate(-681.496 -285.863)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38330",
    "data-name": "Path 38330",
    d: "M656.82,347.954a2.469,2.469,0,0,1-.25.132,2.406,2.406,0,0,0,.25-.132",
    transform: "translate(-644.989 -305.257)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38331",
    "data-name": "Path 38331",
    d: "M730.15,309.775c.061.05.126.094.182.15-.055-.055-.121-.1-.182-.15",
    transform: "translate(-681.876 -286.117)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38332",
    "data-name": "Path 38332",
    d: "M661.874,344.557c-.053.009-.106.021-.159.033.053-.012.105-.024.159-.033",
    transform: "translate(-647.568 -303.554)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38333",
    "data-name": "Path 38333",
    d: "M705.4,344.465a2.361,2.361,0,0,0-.243.075,2.4,2.4,0,0,1,.243-.075",
    transform: "translate(-669.347 -303.508)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38334",
    "data-name": "Path 38334",
    d: "M731.306,311.153a2.364,2.364,0,0,1,.122.223,2.364,2.364,0,0,0-.122-.223",
    transform: "translate(-682.456 -286.808)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38335",
    "data-name": "Path 38335",
    d: "M661.026,344.787c-.051.018-.1.037-.151.059.049-.022.1-.04.151-.059",
    transform: "translate(-647.147 -303.669)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38336",
    "data-name": "Path 38336",
    d: "M660.22,345.187c-.041.025-.083.046-.123.073.04-.027.082-.048.123-.073",
    transform: "translate(-646.757 -303.87)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38337",
    "data-name": "Path 38337",
    d: "M730.8,310.419c.051.061.107.117.151.183-.044-.065-.1-.122-.151-.183",
    transform: "translate(-682.202 -286.44)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38338",
    "data-name": "Path 38338",
    d: "M654.05,348.51c-.071-.007-.141-.007-.211-.02.07.013.141.012.211.02",
    transform: "translate(-643.62 -305.526)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38339",
    "data-name": "Path 38339",
    d: "M721.965,307.287a2.418,2.418,0,0,0,.21.19,2.366,2.366,0,0,1-.21-.19",
    transform: "translate(-677.773 -284.87)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38340",
    "data-name": "Path 38340",
    d: "M652.279,347.879c-.055-.03-.114-.052-.167-.087.053.035.112.057.167.087",
    transform: "translate(-642.754 -305.176)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38341",
    "data-name": "Path 38341",
    d: "M728.542,308.912c.074.023.151.039.221.069-.071-.03-.148-.046-.221-.069",
    transform: "translate(-681.07 -285.684)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38342",
    "data-name": "Path 38342",
    d: "M650.237,342.048c.009-.025.012-.052.022-.077-.01.025-.013.051-.022.077",
    transform: "translate(-641.814 -302.257)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38343",
    "data-name": "Path 38343",
    d: "M721.011,305.961a2.335,2.335,0,0,0,.15.276,2.335,2.335,0,0,1-.15-.276",
    transform: "translate(-677.294 -284.205)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38344",
    "data-name": "Path 38344",
    d: "M722.611,307.814a2.4,2.4,0,0,0,.219.141,2.4,2.4,0,0,1-.219-.141",
    transform: "translate(-678.097 -285.134)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38345",
    "data-name": "Path 38345",
    d: "M653.145,348.287c-.065-.02-.133-.032-.2-.058.064.025.132.038.2.058",
    transform: "translate(-643.173 -305.395)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38346",
    "data-name": "Path 38346",
    d: "M727.6,308.723c.08.008.162.009.24.024-.078-.015-.161-.016-.24-.024",
    transform: "translate(-680.598 -285.59)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38347",
    "data-name": "Path 38347",
    d: "M723.344,308.227c.072.032.142.069.217.095-.075-.026-.145-.062-.217-.095",
    transform: "translate(-678.464 -285.341)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38348",
    "data-name": "Path 38348",
    d: "M724.117,308.5c.073.019.145.043.22.055-.075-.012-.147-.036-.22-.055",
    transform: "translate(-678.852 -285.479)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38349",
    "data-name": "Path 38349",
    d: "M655.932,348.333a2.33,2.33,0,0,1-.255.076,2.33,2.33,0,0,0,.255-.076",
    transform: "translate(-644.542 -305.447)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38350",
    "data-name": "Path 38350",
    d: "M710.238,280.742l-.308.311h0Z",
    transform: "translate(-671.739 -271.562)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38351",
    "data-name": "Path 38351",
    d: "M717.89,280.03h0c-.025-.025-.054-.042-.08-.065.026.023.055.04.08.065",
    transform: "translate(-675.69 -271.173)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38352",
    "data-name": "Path 38352",
    d: "M680.972,358.964c-.046-.056-.1-.107-.139-.167.041.06.093.111.139.167",
    transform: "translate(-657.153 -310.693)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38353",
    "data-name": "Path 38353",
    d: "M681.6,359.649c-.058-.048-.121-.09-.174-.143.053.053.116.1.174.143",
    transform: "translate(-657.448 -311.048)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38354",
    "data-name": "Path 38354",
    d: "M682.327,360.2c-.064-.035-.132-.064-.193-.1.06.04.128.069.193.1",
    transform: "translate(-657.805 -311.341)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38355",
    "data-name": "Path 38355",
    d: "M683.163,360.6c-.07-.022-.144-.037-.211-.065.067.028.141.043.211.065",
    transform: "translate(-658.215 -311.562)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38356",
    "data-name": "Path 38356",
    d: "M684.081,360.833c-.075-.008-.154-.008-.227-.023.073.015.152.015.227.023",
    transform: "translate(-658.667 -311.702)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38357",
    "data-name": "Path 38357",
    d: "M690.2,275.262a2.426,2.426,0,0,1-.7-1.185,2.426,2.426,0,0,0,.7,1.185",
    transform: "translate(-661.498 -268.221)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38358",
    "data-name": "Path 38358",
    d: "M697.49,272.191a2.32,2.32,0,0,0,.334.168,2.32,2.32,0,0,1-.334-.168,18.469,18.469,0,0,0-1.728-.937l1.021-2.536a3.2,3.2,0,1,0-2.145-.864l-1.022,2.537c-.533-.175-1.074-.331-1.627-.458a2.33,2.33,0,0,1-1.019-.53,2.33,2.33,0,0,0,1.019.53,18.325,18.325,0,0,1,5.5,2.258",
    transform: "translate(-662.234 -262.334)",
    fill: "#df98c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38359",
    "data-name": "Path 38359",
    d: "M706.559,282.774c-.052,0-.1.008-.156.007.017,0,.034,0,.05,0,.035,0,.07-.009.106-.01",
    transform: "translate(-669.971 -272.581)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38360",
    "data-name": "Path 38360",
    d: "M715.709,292.894a18.36,18.36,0,0,1,1.364,2.63c-.153-.365-.321-.723-.5-1.075-.265-.533-.553-1.052-.867-1.554a2.327,2.327,0,0,1-.353-1.134,2.327,2.327,0,0,0,.353,1.134",
    transform: "translate(-674.46 -277.086)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38361",
    "data-name": "Path 38361",
    d: "M725.159,308.662a2.263,2.263,0,0,1-.226-.018c.072.007.144.018.217.018Z",
    transform: "translate(-679.261 -285.55)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38362",
    "data-name": "Path 38362",
    d: "M721.622,306.909a2.334,2.334,0,0,1-.179-.227,2.334,2.334,0,0,0,.179.227",
    transform: "translate(-677.511 -284.566)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38363",
    "data-name": "Path 38363",
    d: "M726.244,308.675h0l-.858,0,.858,0Z",
    transform: "translate(-679.488 -285.565)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38364",
    "data-name": "Path 38364",
    d: "M663.409,344.531c-.081-.014-.162-.023-.244-.03.081.006.163.016.244.03",
    transform: "translate(-648.295 -303.526)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38365",
    "data-name": "Path 38365",
    d: "M664.15,344.686a2.337,2.337,0,0,0-.242-.073,2.31,2.31,0,0,1,.242.073",
    transform: "translate(-648.668 -303.582)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38366",
    "data-name": "Path 38366",
    d: "M680.476,358.146c-.029-.055-.065-.106-.089-.164.024.058.06.108.089.164",
    transform: "translate(-656.929 -310.284)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38367",
    "data-name": "Path 38367",
    d: "M728.955,313.249a2.4,2.4,0,0,1-2.391,2.408l-.572,0,.572,0a2.4,2.4,0,0,0,2.391-2.408h0c0-.075-.016-.146-.023-.219.007.073.022.145.023.219Z",
    transform: "translate(-679.792 -287.748)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38368",
    "data-name": "Path 38368",
    d: "M680.143,357.2c-.011-.041-.029-.079-.038-.121.008.042.027.08.038.121",
    transform: "translate(-656.788 -309.832)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38369",
    "data-name": "Path 38369",
    d: "M717.376,285.5l.308-.31a2.389,2.389,0,0,0,.7-1.7,2.391,2.391,0,0,1-.7,1.7Z",
    transform: "translate(-675.472 -272.941)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38370",
    "data-name": "Path 38370",
    d: "M679.827,353.221a2.479,2.479,0,0,0-.1-.428,2.479,2.479,0,0,1,.1.428",
    transform: "translate(-656.596 -307.683)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38371",
    "data-name": "Path 38371",
    d: "M731.67,311.984a2.228,2.228,0,0,1,.081.258,2.228,2.228,0,0,0-.081-.258",
    transform: "translate(-682.638 -287.224)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38372",
    "data-name": "Path 38372",
    d: "M654.026,278.935a2.345,2.345,0,0,1,.25-.024,2.345,2.345,0,0,0-.25.024",
    transform: "translate(-643.714 -270.644)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38373",
    "data-name": "Path 38373",
    d: "M653.123,279.073a2.306,2.306,0,0,1,.241-.072,2.306,2.306,0,0,0-.241.072",
    transform: "translate(-643.261 -270.689)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38374",
    "data-name": "Path 38374",
    d: "M652.24,279.393a2.269,2.269,0,0,1,.236-.125,2.269,2.269,0,0,0-.236.125",
    transform: "translate(-642.818 -270.823)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38375",
    "data-name": "Path 38375",
    d: "M655.058,278.959c.064.007.129.007.193.018-.064-.012-.129-.011-.193-.018",
    transform: "translate(-644.231 -270.668)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38376",
    "data-name": "Path 38376",
    d: "M716.854,279.294c.06.032.123.057.18.094-.057-.037-.12-.062-.18-.094",
    transform: "translate(-675.211 -270.836)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38377",
    "data-name": "Path 38377",
    d: "M688.2,268.121c.049.059.1.114.147.178-.043-.064-.1-.119-.147-.178",
    transform: "translate(-660.847 -265.235)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38378",
    "data-name": "Path 38378",
    d: "M689.132,269.893c.014.051.036.1.047.15-.01-.052-.033-.1-.047-.15",
    transform: "translate(-661.313 -266.123)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38379",
    "data-name": "Path 38379",
    d: "M637.55,314.944c-.017-.058-.042-.113-.054-.173.012.06.037.115.054.173",
    transform: "translate(-635.427 -288.622)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38380",
    "data-name": "Path 38380",
    d: "M688.733,268.908a2.175,2.175,0,0,1,.1.192,2.175,2.175,0,0,0-.1-.192",
    transform: "translate(-661.113 -265.63)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38381",
    "data-name": "Path 38381",
    d: "M651.287,279.952a2.433,2.433,0,0,1,.294-.241,2.433,2.433,0,0,0-.294.241",
    transform: "translate(-642.341 -271.045)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38382",
    "data-name": "Path 38382",
    d: "M653.08,289.284a2.425,2.425,0,0,0-.252-.4,2.425,2.425,0,0,1,.252.4",
    transform: "translate(-643.113 -275.645)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38383",
    "data-name": "Path 38383",
    d: "M637.88,315.858c-.033-.062-.073-.121-.1-.186.028.065.068.124.1.186",
    transform: "translate(-635.569 -289.073)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38384",
    "data-name": "Path 38384",
    d: "M663.685,282.735a2.357,2.357,0,0,0,.241-.074,2.32,2.32,0,0,1-.241.074",
    transform: "translate(-648.556 -272.524)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38385",
    "data-name": "Path 38385",
    d: "M686.776,266.956a2.307,2.307,0,0,1,.21.114,2.307,2.307,0,0,0-.21-.114",
    transform: "translate(-660.132 -264.651)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38386",
    "data-name": "Path 38386",
    d: "M685.922,266.6a2.359,2.359,0,0,1,.228.071,2.359,2.359,0,0,0-.228-.071",
    transform: "translate(-659.704 -264.473)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38387",
    "data-name": "Path 38387",
    d: "M662.946,282.894c.08-.007.16-.016.24-.031-.08.014-.16.024-.24.031",
    transform: "translate(-648.185 -272.626)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38388",
    "data-name": "Path 38388",
    d: "M679.788,269.826a2.387,2.387,0,0,1,.143-.5,2.387,2.387,0,0,0-.143.5",
    transform: "translate(-656.629 -265.838)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38389",
    "data-name": "Path 38389",
    d: "M656.872,279.538c.049.027.1.047.15.078-.048-.031-.1-.051-.15-.078",
    transform: "translate(-645.141 -270.959)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38390",
    "data-name": "Path 38390",
    d: "M659.869,282.11c.04.027.082.048.124.073-.041-.024-.084-.046-.124-.073",
    transform: "translate(-646.643 -272.248)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38391",
    "data-name": "Path 38391",
    d: "M660.643,282.533c.05.022.1.04.154.059-.052-.018-.1-.037-.154-.059",
    transform: "translate(-647.031 -272.46)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38392",
    "data-name": "Path 38392",
    d: "M661.476,282.808c.054.013.108.024.163.033-.055-.009-.109-.021-.163-.033",
    transform: "translate(-647.449 -272.598)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38393",
    "data-name": "Path 38393",
    d: "M687.539,267.464c.062.051.128.1.184.152-.056-.056-.123-.1-.184-.152",
    transform: "translate(-660.514 -264.906)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38394",
    "data-name": "Path 38394",
    d: "M655.973,279.151c.06.019.122.03.181.053-.059-.023-.121-.034-.181-.053",
    transform: "translate(-644.69 -270.765)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38395",
    "data-name": "Path 38395",
    d: "M712.234,279.194a2.419,2.419,0,0,1,.261-.138,2.419,2.419,0,0,0-.261.138",
    transform: "translate(-672.894 -270.717)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38396",
    "data-name": "Path 38396",
    d: "M713.122,278.867a2.359,2.359,0,0,1,.264-.078,2.359,2.359,0,0,0-.264.078",
    transform: "translate(-673.34 -270.583)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38397",
    "data-name": "Path 38397",
    d: "M714.03,278.725a2.37,2.37,0,0,1,.27-.026,2.37,2.37,0,0,0-.27.026",
    transform: "translate(-673.795 -270.538)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38398",
    "data-name": "Path 38398",
    d: "M708.151,282.427c.051-.019.1-.037.151-.059-.049.022-.1.041-.151.059",
    transform: "translate(-670.848 -272.377)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38399",
    "data-name": "Path 38399",
    d: "M711.234,279.78a2.421,2.421,0,0,1,.343-.281,2.421,2.421,0,0,0-.343.281",
    transform: "translate(-672.393 -270.939)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38400",
    "data-name": "Path 38400",
    d: "M638.358,316.649c-.044-.054-.094-.1-.133-.161.039.058.089.107.133.161",
    transform: "translate(-635.792 -289.482)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38401",
    "data-name": "Path 38401",
    d: "M648.153,321.008a2.374,2.374,0,0,0-.135-.25,2.374,2.374,0,0,1,.135.25",
    transform: "translate(-640.702 -291.623)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38402",
    "data-name": "Path 38402",
    d: "M715.978,278.928c.067.02.135.033.2.059-.065-.026-.133-.039-.2-.059",
    transform: "translate(-674.771 -270.653)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38403",
    "data-name": "Path 38403",
    d: "M715.067,278.745c.07.007.141.007.211.02-.069-.013-.14-.013-.211-.02",
    transform: "translate(-674.315 -270.561)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38404",
    "data-name": "Path 38404",
    d: "M647.135,319.778a2.413,2.413,0,0,0-.192-.174,2.413,2.413,0,0,1,.192.174",
    transform: "translate(-640.163 -291.044)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38405",
    "data-name": "Path 38405",
    d: "M708.986,282.012c.041-.024.083-.046.123-.073-.039.027-.082.048-.123.073",
    transform: "translate(-671.266 -272.162)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38406",
    "data-name": "Path 38406",
    d: "M640.551,318.288c-.069-.022-.141-.036-.207-.064.066.027.138.042.207.064",
    transform: "translate(-636.855 -290.353)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38407",
    "data-name": "Path 38407",
    d: "M641.456,318.522c-.07-.008-.142-.008-.209-.021.067.013.139.013.209.021",
    transform: "translate(-637.307 -290.491)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38408",
    "data-name": "Path 38408",
    d: "M639.724,317.889c-.066-.036-.136-.065-.2-.107.062.041.132.071.2.107",
    transform: "translate(-636.445 -290.131)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38409",
    "data-name": "Path 38409",
    d: "M644.99,318.715a2.192,2.192,0,0,0-.221-.055,2.192,2.192,0,0,1,.221.055",
    transform: "translate(-639.073 -290.571)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38410",
    "data-name": "Path 38410",
    d: "M638.983,317.337c-.056-.047-.118-.088-.17-.139.052.051.113.092.17.139",
    transform: "translate(-636.087 -289.838)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38411",
    "data-name": "Path 38411",
    d: "M704.934,282.514a2.112,2.112,0,0,0,.243.073,2.138,2.138,0,0,1-.243-.073",
    transform: "translate(-669.235 -272.451)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38412",
    "data-name": "Path 38412",
    d: "M707.3,282.683c.053-.009.106-.021.159-.033-.053.012-.105.024-.159.033",
    transform: "translate(-670.419 -272.519)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38413",
    "data-name": "Path 38413",
    d: "M646.488,319.309c-.069-.046-.136-.1-.209-.135.073.04.14.089.209.135",
    transform: "translate(-639.83 -290.829)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38414",
    "data-name": "Path 38414",
    d: "M705.675,282.712a2.375,2.375,0,0,0,.244.03,2.375,2.375,0,0,1-.244-.03",
    transform: "translate(-669.606 -272.55)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38415",
    "data-name": "Path 38415",
    d: "M645.765,318.949c-.071-.032-.14-.068-.214-.093.074.025.143.061.214.093",
    transform: "translate(-639.465 -290.669)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38416",
    "data-name": "Path 38416",
    d: "M679.71,272.9v0Z",
    transform: "translate(-656.59 -267.632)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38417",
    "data-name": "Path 38417",
    d: "M716.883,347.723a2.453,2.453,0,0,1-.269.142,2.453,2.453,0,0,0,.269-.142",
    transform: "translate(-675.09 -305.141)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38418",
    "data-name": "Path 38418",
    d: "M715.986,348.116a2.53,2.53,0,0,1-.265.079,2.53,2.53,0,0,0,.265-.079",
    transform: "translate(-674.643 -305.338)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38419",
    "data-name": "Path 38419",
    d: "M684.994,266.416a2.41,2.41,0,0,1,.241.024,2.41,2.41,0,0,0-.241-.024",
    transform: "translate(-659.239 -264.38)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38420",
    "data-name": "Path 38420",
    d: "M662.527,282.935c-.056,0-.112,0-.168-.007.036,0,.071.01.107.01.02,0,.04,0,.061,0",
    transform: "translate(-647.891 -272.659)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38421",
    "data-name": "Path 38421",
    d: "M668.05,278.95c-.509.19-1.006.4-1.493.636a18.317,18.317,0,0,0-1.831,1,2.336,2.336,0,0,1-.334.171,2.31,2.31,0,0,0,.334-.171,18.333,18.333,0,0,1,3.324-1.64",
    transform: "translate(-648.91 -270.664)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38422",
    "data-name": "Path 38422",
    d: "M652.6,338.246a2.378,2.378,0,0,1-.338.441l-.309.311.309-.311a2.378,2.378,0,0,0,.338-.441",
    transform: "translate(-642.674 -300.39)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38423",
    "data-name": "Path 38423",
    d: "M653.879,335.514a2.408,2.408,0,0,1-.093.776,2.408,2.408,0,0,0,.093-.776",
    transform: "translate(-643.593 -299.02)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38424",
    "data-name": "Path 38424",
    d: "M658.162,346.53h0l.617-.621h0Z",
    transform: "translate(-645.787 -304.231)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38425",
    "data-name": "Path 38425",
    d: "M689.326,271.145v-.006c0-.008,0-.015,0-.023,0,.008,0,.015,0,.023Z",
    transform: "translate(-661.409 -266.737)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38426",
    "data-name": "Path 38426",
    d: "M682.8,266.368h0a2.389,2.389,0,0,0-1.694.709,2.389,2.389,0,0,1,1.694-.709Z",
    transform: "translate(-657.287 -264.356)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38427",
    "data-name": "Path 38427",
    d: "M715.058,348.314a2.467,2.467,0,0,1-.257.025,2.467,2.467,0,0,0,.257-.025",
    transform: "translate(-674.181 -305.437)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38428",
    "data-name": "Path 38428",
    d: "M649.937,343.782a2.389,2.389,0,0,0,.708,1.694c.014.013.03.022.044.035-.014-.014-.03-.022-.044-.035a2.389,2.389,0,0,1-.708-1.694",
    transform: "translate(-641.664 -303.165)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38429",
    "data-name": "Path 38429",
    d: "M662.313,267.785a.985.985,0,0,0-.98.987l0,.857a3.8,3.8,0,0,1-2.908,3.734,16.9,16.9,0,0,0-5.062,2.121,3.759,3.759,0,0,1-1.992.57,3.8,3.8,0,0,1-2.694-1.112l-.621-.617a.983.983,0,1,0-1.385,1.4l.621.617a3.779,3.779,0,0,1,.574,4.682,16.891,16.891,0,0,0-2.084,5.077,3.794,3.794,0,0,1-3.713,2.933l-.656,0h-.2a.982.982,0,0,0-.98.986.986.986,0,0,0,.983.981l.861,0a3.8,3.8,0,0,1,3.735,2.908,16.886,16.886,0,0,0,2.12,5.062,3.78,3.78,0,0,1-.542,4.686l-.617.621a.984.984,0,0,0,1.4,1.386l.617-.621a3.848,3.848,0,0,1,2.713-1.132,3.758,3.758,0,0,1,1.969.557,16.906,16.906,0,0,0,5.077,2.085,3.793,3.793,0,0,1,2.933,3.714l0,.858a.983.983,0,0,0,1.682.689.974.974,0,0,0,.285-.7l0-.859a3.794,3.794,0,0,1,2.907-3.734,16.882,16.882,0,0,0,5.061-2.12,3.749,3.749,0,0,1,1.992-.571,3.8,3.8,0,0,1,2.694,1.113l.621.617a.983.983,0,1,0,1.385-1.4l-.621-.617a3.78,3.78,0,0,1-.575-4.682A16.9,16.9,0,0,0,679,293.787a3.794,3.794,0,0,1,3.713-2.934l.736,0h.121a.983.983,0,0,0,.98-.986.985.985,0,0,0-.983-.98l-.861,0a3.8,3.8,0,0,1-3.734-2.908,16.893,16.893,0,0,0-2.12-5.062,3.78,3.78,0,0,1,.542-4.686l.616-.621a.983.983,0,1,0-1.4-1.385l-.616.62a3.85,3.85,0,0,1-2.713,1.132,3.748,3.748,0,0,1-1.969-.557,16.9,16.9,0,0,0-5.076-2.085,3.794,3.794,0,0,1-2.934-3.713l0-.857a.985.985,0,0,0-.983-.98V266.37Z",
    transform: "translate(-636.8 -264.357)",
    fill: "#b697c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38430",
    "data-name": "Path 38430",
    d: "M652.967,294.013c-.021.04-.037.082-.061.122-.076.123-.148.249-.221.374.073-.125.145-.251.221-.374.024-.039.039-.081.061-.122",
    transform: "translate(-643.041 -278.215)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38431",
    "data-name": "Path 38431",
    d: "M653.333,289.684a2.412,2.412,0,0,1,.243,1.144,2.412,2.412,0,0,0-.243-1.144",
    transform: "translate(-643.366 -276.045)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38432",
    "data-name": "Path 38432",
    d: "M643.943,318.591a2.24,2.24,0,0,1,.226.018c-.072-.007-.144-.018-.217-.018Z",
    transform: "translate(-638.659 -290.537)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38433",
    "data-name": "Path 38433",
    d: "M641.093,308.971h-.429a2.377,2.377,0,0,0-1.517.562,2.377,2.377,0,0,1,1.517-.562h.429",
    transform: "translate(-636.255 -285.714)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38434",
    "data-name": "Path 38434",
    d: "M715.541,336.009a2.4,2.4,0,0,0,.329.96,2.4,2.4,0,0,1-.329-.96",
    transform: "translate(-674.552 -299.269)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38435",
    "data-name": "Path 38435",
    d: "M646.183,307.4a2.427,2.427,0,0,1-1.292.725,2.427,2.427,0,0,0,1.292-.725",
    transform: "translate(-639.134 -284.927)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38436",
    "data-name": "Path 38436",
    d: "M714.074,348.3c-.064-.007-.128-.006-.191-.018.063.012.127.011.191.018",
    transform: "translate(-673.721 -305.419)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38437",
    "data-name": "Path 38437",
    d: "M718.8,340.892a2.4,2.4,0,0,1,.4,1.32,2.4,2.4,0,0,0-.4-1.32",
    transform: "translate(-676.187 -301.716)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38438",
    "data-name": "Path 38438",
    d: "M650.529,327.967c.148.351.309.695.477,1.034.271.547.565,1.081.887,1.6a2.323,2.323,0,0,1,.346,1.083,2.323,2.323,0,0,0-.346-1.083,18.4,18.4,0,0,1-1.364-2.63",
    transform: "translate(-641.961 -295.237)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38439",
    "data-name": "Path 38439",
    d: "M658.758,281.133l0,0-.414-.41.414.41,0,0",
    transform: "translate(-645.877 -271.551)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38440",
    "data-name": "Path 38440",
    d: "M649.845,282.33a2.4,2.4,0,0,0,.065,1.6,2.4,2.4,0,0,1-.065-1.6",
    transform: "translate(-641.564 -272.358)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38441",
    "data-name": "Path 38441",
    d: "M648.4,321.463a2.332,2.332,0,0,1,.129.387c.043.182.092.363.141.543-.049-.18-.1-.36-.141-.543a2.332,2.332,0,0,0-.129-.387",
    transform: "translate(-640.893 -291.976)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38442",
    "data-name": "Path 38442",
    d: "M717.779,347.025a2.5,2.5,0,0,1-.327.269,2.5,2.5,0,0,0,.327-.269",
    transform: "translate(-675.51 -304.791)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38443",
    "data-name": "Path 38443",
    d: "M647.528,320.135a2.273,2.273,0,0,1,.168.213,2.273,2.273,0,0,0-.168-.213",
    transform: "translate(-640.456 -291.311)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38444",
    "data-name": "Path 38444",
    d: "M662.614,344.489c.052,0,.1-.008.156-.007-.017,0-.034,0-.051,0-.035,0-.07.009-.105.01",
    transform: "translate(-648.019 -303.515)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38445",
    "data-name": "Path 38445",
    d: "M708.53,344.682c-.051-.022-.1-.04-.154-.059.052.018.1.037.154.059",
    transform: "translate(-670.96 -303.587)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38446",
    "data-name": "Path 38446",
    d: "M689.62,352.855a2.443,2.443,0,0,1,.5-1.5,2.442,2.442,0,0,0-.5,1.495Z",
    transform: "translate(-661.558 -306.964)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38447",
    "data-name": "Path 38447",
    d: "M686.488,358.329a2.393,2.393,0,0,0,1.565-2.25,2.393,2.393,0,0,1-1.565,2.25",
    transform: "translate(-659.987 -309.33)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38448",
    "data-name": "Path 38448",
    d: "M709.334,345.091c-.04-.027-.083-.048-.124-.073.041.024.084.045.124.073",
    transform: "translate(-671.378 -303.785)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38449",
    "data-name": "Path 38449",
    d: "M712.286,347.647c-.042-.024-.087-.04-.128-.067.041.027.086.043.128.067",
    transform: "translate(-672.856 -305.069)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38450",
    "data-name": "Path 38450",
    d: "M696.183,346.752l.037-.013a18.588,18.588,0,0,0,3.993-1.875,2.341,2.341,0,0,1,.335-.171,2.341,2.341,0,0,0-.335.171,18.327,18.327,0,0,1-4.031,1.888",
    transform: "translate(-664.848 -303.622)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38451",
    "data-name": "Path 38451",
    d: "M706.141,344.349c-.081.007-.161.016-.241.031.08-.014.161-.024.241-.031",
    transform: "translate(-669.719 -303.45)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38452",
    "data-name": "Path 38452",
    d: "M707.688,344.432c-.054-.012-.108-.024-.163-.033.055.009.109.021.163.033",
    transform: "translate(-670.533 -303.475)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38453",
    "data-name": "Path 38453",
    d: "M664.614,344.837a2.38,2.38,0,0,1,.334.168c.321.2.652.383.986.563-.334-.179-.665-.364-.986-.562a2.38,2.38,0,0,0-.334-.168",
    transform: "translate(-649.022 -303.694)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38454",
    "data-name": "Path 38454",
    d: "M690.631,351.067a2.4,2.4,0,0,1,.265-.292,2.4,2.4,0,0,0-.265.292",
    transform: "translate(-662.064 -306.671)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38455",
    "data-name": "Path 38455",
    d: "M706.631,344.328c.057,0,.113,0,.17.006-.036,0-.072-.01-.108-.01-.021,0-.041,0-.061,0",
    transform: "translate(-670.086 -303.437)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38456",
    "data-name": "Path 38456",
    d: "M710.154,345.729h0l.208.206-.208-.206h0",
    transform: "translate(-671.852 -304.141)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38457",
    "data-name": "Path 38457",
    d: "M713.169,348.069c-.058-.018-.118-.029-.175-.052.057.023.117.033.175.052",
    transform: "translate(-673.275 -305.288)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38458",
    "data-name": "Path 38458",
    d: "M672.748,278.262c-.123.038-.246.074-.368.115-.22.072-.437.148-.653.228.335-.125.677-.237,1.021-.343",
    transform: "translate(-652.588 -270.319)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38459",
    "data-name": "Path 38459",
    d: "M719.733,302.162a2.326,2.326,0,0,0,.129.388,2.326,2.326,0,0,1-.129-.388,18.223,18.223,0,0,0-.531-1.8c-.125-.357-.256-.71-.4-1.057a18.306,18.306,0,0,1,.933,2.856",
    transform: "translate(-676.186 -280.869)",
    fill: "#85b9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38460",
    "data-name": "Path 38460",
    d: "M642.732,292.825c-.187.342-.364.689-.529,1.043l-2.471-.95a3.195,3.195,0,1,0-.829,2.159l2.456.944c-.047.147-.089.3-.132.443a18.267,18.267,0,0,1,1.506-3.639",
    transform: "translate(-633.347 -276.072)",
    fill: "#df98c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38461",
    "data-name": "Path 38461",
    d: "M678.31,296.27a18.237,18.237,0,0,0,.642-2.167,2.386,2.386,0,0,1,1.966-1.8,2.432,2.432,0,0,1,.373-.033h.286l.572,0a2.4,2.4,0,0,0,2.391-2.408h0c0-.075-.016-.146-.023-.219a2.414,2.414,0,0,0-.027-.264,2.282,2.282,0,0,0-.081-.258c-.021-.063-.034-.13-.06-.192a2.4,2.4,0,0,0-.122-.223c-.034-.061-.061-.126-.1-.184a2.335,2.335,0,0,0-.152-.182c-.047-.057-.09-.119-.142-.171s-.121-.1-.182-.15-.111-.1-.174-.142-.137-.074-.2-.111a2.259,2.259,0,0,0-.2-.109c-.07-.03-.148-.046-.221-.069s-.149-.054-.228-.07-.161-.016-.241-.024a2.319,2.319,0,0,0-.238-.024h-.008l-.857,0h-.009c-.074,0-.145-.011-.218-.018s-.125-.005-.186-.015-.147-.036-.22-.055c-.056-.015-.114-.024-.169-.043-.075-.026-.145-.062-.217-.095-.048-.022-.1-.039-.147-.064a2.542,2.542,0,0,1-.219-.142c-.036-.025-.077-.045-.112-.073a2.351,2.351,0,0,1-.21-.19c-.026-.026-.056-.047-.082-.074a2.413,2.413,0,0,1-.179-.227c-.021-.029-.046-.054-.065-.083a2.351,2.351,0,0,1-.15-.276c-.012-.026-.029-.049-.041-.075a2.352,2.352,0,0,1-.129-.388,18.366,18.366,0,0,0-2.3-5.485,2.33,2.33,0,0,1-.353-1.134,2.4,2.4,0,0,1,.235-1.145,2.416,2.416,0,0,1,.464-.658l.308-.31.308-.311a2.364,2.364,0,0,0,.4-2.822,2.337,2.337,0,0,0-.412-.57c-.025-.025-.054-.042-.08-.065a2.437,2.437,0,0,0-.3-.24c-.058-.037-.121-.062-.181-.094a2.328,2.328,0,0,0-.237-.124c-.065-.026-.133-.038-.2-.059a2.392,2.392,0,0,0-.244-.071c-.069-.013-.14-.013-.21-.02a2.374,2.374,0,0,0-.243-.023h0a2.353,2.353,0,0,0-.27.026c-.063.007-.127.007-.189.019a2.487,2.487,0,0,0-.264.078c-.06.019-.123.03-.182.055a2.434,2.434,0,0,0-.261.138c-.052.029-.106.05-.156.083a2.43,2.43,0,0,0-.343.281c-.011.01-.023.017-.034.028l-.308.311-.308.31h0a2.439,2.439,0,0,1-.347.286c-.04.027-.082.048-.123.073a2.423,2.423,0,0,1-.265.142c-.05.022-.1.04-.151.059a2.342,2.342,0,0,1-.268.081c-.053.013-.105.025-.159.034a2.431,2.431,0,0,1-.29.028c-.035,0-.07.01-.105.01-.017,0-.034,0-.051,0-.039,0-.079,0-.119-.008a2.4,2.4,0,0,1-.244-.03c-.042-.008-.084-.016-.126-.026a2.363,2.363,0,0,1-.244-.073c-.036-.013-.073-.024-.108-.039a2.277,2.277,0,0,1-.335-.168,18.34,18.34,0,0,0-5.5-2.259,2.319,2.319,0,0,1-1.019-.53c-.011-.01-.024-.017-.035-.027a2.55,2.55,0,0,1-.781-1.781l0-.852v-.006c0-.008,0-.015,0-.022a2.409,2.409,0,0,0-.048-.46c-.011-.052-.033-.1-.047-.15a2.385,2.385,0,0,0-.094-.3c-.029-.068-.07-.128-.1-.192s-.072-.147-.117-.214-.1-.119-.148-.178-.092-.122-.146-.176-.123-.1-.185-.152-.11-.1-.17-.14-.14-.076-.21-.113a2.214,2.214,0,0,0-.2-.106,2.35,2.35,0,0,0-.229-.071c-.074-.022-.145-.052-.221-.068a2.4,2.4,0,0,0-.241-.024,2.35,2.35,0,0,0-.238-.024h0v1.415a.986.986,0,0,1,.983.98l0,.857a3.794,3.794,0,0,0,2.933,3.714,16.885,16.885,0,0,1,5.077,2.085,3.752,3.752,0,0,0,1.969.557,3.85,3.85,0,0,0,2.713-1.132l.616-.621a.983.983,0,0,1,1.4,1.385l-.616.621a3.78,3.78,0,0,0-.542,4.686,16.909,16.909,0,0,1,2.12,5.062,3.8,3.8,0,0,0,3.734,2.907l.861,0a.983.983,0,0,1,0,1.967h-.121l-.737,0a3.792,3.792,0,0,0-3.713,2.934,16.913,16.913,0,0,1-2.085,5.077,3.779,3.779,0,0,0,.575,4.682l.621.617a.983.983,0,0,1-1.385,1.4l-.621-.617a3.8,3.8,0,0,0-2.695-1.113,3.747,3.747,0,0,0-1.991.571,16.9,16.9,0,0,1-5.061,2.12,3.793,3.793,0,0,0-2.907,3.734l0,.858a.984.984,0,0,1-1.967.007l0-.858a3.794,3.794,0,0,0-2.933-3.713,16.887,16.887,0,0,1-5.077-2.085,3.752,3.752,0,0,0-1.969-.556,3.848,3.848,0,0,0-2.713,1.132l-.617.621a.983.983,0,0,1-1.4-1.386l.617-.621a3.78,3.78,0,0,0,.542-4.686,16.888,16.888,0,0,1-2.12-5.062,3.8,3.8,0,0,0-3.735-2.907l-.861,0a.984.984,0,0,1,0-1.967h.2l.656,0a3.793,3.793,0,0,0,3.713-2.933,16.908,16.908,0,0,1,2.085-5.076,3.78,3.78,0,0,0-.575-4.682l-.621-.617a.983.983,0,1,1,1.386-1.4l.621.616a3.8,3.8,0,0,0,2.694,1.113,3.752,3.752,0,0,0,1.991-.57,16.9,16.9,0,0,1,5.063-2.12,3.794,3.794,0,0,0,2.907-3.735l0-.857a.985.985,0,0,1,.98-.987l0-1.415h-.009a2.4,2.4,0,0,0-2.206,1.473,2.648,2.648,0,0,0-.185.935l0,.851v.005a2.4,2.4,0,0,1-1.819,2.352c-.386.092-.766.2-1.142.315-.344.106-.685.218-1.021.343a18.343,18.343,0,0,0-3.324,1.64,2.32,2.32,0,0,1-.334.171c-.036.015-.074.026-.111.04a2.205,2.205,0,0,1-.241.074c-.043.01-.086.019-.129.027-.079.014-.159.024-.239.031-.042,0-.083.007-.125.008-.02,0-.04,0-.06,0-.036,0-.072-.008-.108-.01a2.317,2.317,0,0,1-.277-.027c-.055-.009-.109-.02-.163-.033a2.422,2.422,0,0,1-.262-.078c-.051-.018-.1-.036-.153-.059a2.394,2.394,0,0,1-.262-.138c-.041-.024-.084-.045-.124-.073a2.362,2.362,0,0,1-.345-.281l0,0-.413-.41-.207-.206a2.418,2.418,0,0,0-.376-.306c-.048-.031-.1-.05-.15-.078a2.429,2.429,0,0,0-.267-.139c-.059-.024-.121-.035-.181-.053a2.478,2.478,0,0,0-.264-.077c-.063-.012-.128-.011-.193-.018a2.407,2.407,0,0,0-.26-.024h0a2.359,2.359,0,0,0-.25.024c-.069.008-.14.008-.209.02s-.161.047-.241.072-.138.034-.2.061a2.452,2.452,0,0,0-.236.125c-.06.033-.123.058-.181.1a2.442,2.442,0,0,0-.294.241c-.026.024-.057.042-.082.068a2.369,2.369,0,0,0-.583,1,2.4,2.4,0,0,0,.065,1.6,2.369,2.369,0,0,0,.221.416,2.406,2.406,0,0,0,.309.376l.621.617a2.411,2.411,0,0,1,.712,1.8,2.339,2.339,0,0,1-.284,1.015c-.022.04-.037.082-.061.121-.076.124-.148.25-.221.375q-.132.227-.26.459a18.349,18.349,0,0,0-1.506,3.639c-.1.339-.192.681-.273,1.028a2.323,2.323,0,0,1-.557,1.054,2.519,2.519,0,0,1-1.781.781l-.43,0h-.429a2.426,2.426,0,0,0-2.39,2.408h0a2.4,2.4,0,0,0,.05.483c.013.06.037.115.054.173a2.387,2.387,0,0,0,.087.276c.029.066.068.124.1.186s.074.152.121.221.089.107.133.16a2.392,2.392,0,0,0,.161.194c.052.052.113.093.169.139a2.358,2.358,0,0,0,.186.153c.062.041.132.071.2.107a2.2,2.2,0,0,0,.21.113c.066.028.138.042.207.064a2.257,2.257,0,0,0,.243.075c.068.013.14.013.209.021a2.4,2.4,0,0,0,.27.027h.009l.857,0h.009c.074,0,.145.012.217.018s.125.005.186.016c.076.012.148.036.221.055.056.015.114.024.168.043.074.025.143.061.214.093.05.023.1.04.15.066a2.449,2.449,0,0,1,.209.135c.04.027.084.05.122.079a2.458,2.458,0,0,1,.191.174c.033.031.069.058.1.091a2.347,2.347,0,0,1,.168.213c.024.033.054.062.077.1a2.422,2.422,0,0,1,.135.25c.017.034.039.066.055.1a2.282,2.282,0,0,1,.129.387c.043.182.092.362.141.543.083.306.171.611.269.911.033.1.071.2.106.3.129.372.266.739.417,1.1a18.436,18.436,0,0,0,1.365,2.63,2.314,2.314,0,0,1,.346,1.083c0,.017.006.033.007.051a2.315,2.315,0,0,1-.363,1.362,2.372,2.372,0,0,1-.337.44l-.309.311-.308.31a2.392,2.392,0,0,0-.525.8c-.01.024-.013.051-.022.077a2.37,2.37,0,0,0,.558,2.52c.014.013.03.022.043.035a2.457,2.457,0,0,0,.333.27c.053.035.112.057.167.088a2.323,2.323,0,0,0,.25.13c.064.026.132.038.2.058a2.571,2.571,0,0,0,.247.072c.07.013.141.013.211.02s.161.023.241.023h0a2.453,2.453,0,0,0,.27-.026c.063-.007.127-.006.19-.018a2.366,2.366,0,0,0,.255-.076c.063-.02.128-.032.19-.057a2.431,2.431,0,0,0,.25-.132c.055-.031.114-.053.168-.089a2.421,2.421,0,0,0,.368-.3l.008-.006.617-.621h0a2.4,2.4,0,0,1,.347-.286c.04-.027.082-.049.123-.074a2.421,2.421,0,0,1,.265-.141c.049-.022.1-.04.151-.059a2.306,2.306,0,0,1,.268-.081c.053-.012.1-.024.159-.033a2.337,2.337,0,0,1,.29-.029c.035,0,.07-.01.105-.01.017,0,.033,0,.05,0,.04,0,.079.005.119.007.082.007.163.016.244.03.042.008.084.016.127.026a2.268,2.268,0,0,1,.242.072c.036.013.073.024.109.039a2.347,2.347,0,0,1,.334.168c.322.2.652.383.986.563q.35.186.709.359a18.353,18.353,0,0,0,2.144.868c.544.18,1.1.34,1.663.47a2.359,2.359,0,0,1,1.538,1.177,2.466,2.466,0,0,1,.161.363,2.427,2.427,0,0,1,.1.429,2.458,2.458,0,0,1,.032.369l0,.858a2.409,2.409,0,0,0,.05.483c.009.042.027.08.038.121a2.492,2.492,0,0,0,.1.328c.024.057.06.108.089.163a2.4,2.4,0,0,0,.133.243c.041.06.092.111.139.167a2.376,2.376,0,0,0,.155.187c.053.053.116.1.174.143s.116.1.181.149.129.069.193.1.14.084.215.116.141.043.211.065a2.4,2.4,0,0,0,.239.073c.073.015.151.015.226.023a2.5,2.5,0,0,0,.252.025h.009a2.428,2.428,0,0,0,2.391-2.408l0-.858h0a2.439,2.439,0,0,1,.5-1.495,2.373,2.373,0,0,1,.265-.292,2.318,2.318,0,0,1,1.05-.565q.739-.176,1.454-.41a18.376,18.376,0,0,0,4.031-1.888,2.271,2.271,0,0,1,.335-.171c.036-.015.073-.026.109-.039a2.388,2.388,0,0,1,.243-.075c.042-.01.085-.018.128-.026a2.351,2.351,0,0,1,.241-.031c.041,0,.082-.007.124-.008.02,0,.04,0,.061,0,.036,0,.072.009.109.01a2.334,2.334,0,0,1,.276.027c.055.009.109.02.164.033a2.417,2.417,0,0,1,.261.078c.052.018.1.036.154.059a2.484,2.484,0,0,1,.262.138c.041.025.084.046.124.073a2.468,2.468,0,0,1,.347.281h0l.207.206.414.411a2.414,2.414,0,0,0,.376.305c.041.027.086.043.129.067a2.413,2.413,0,0,0,.288.151c.057.023.117.033.175.052a2.472,2.472,0,0,0,.269.078c.063.012.127.011.19.018a2.448,2.448,0,0,0,.262.025h0a2.338,2.338,0,0,0,.257-.025c.067-.007.135-.007.2-.02a2.4,2.4,0,0,0,.265-.079c.06-.019.122-.03.18-.054a2.431,2.431,0,0,0,.268-.142c.049-.028.1-.048.149-.079a2.406,2.406,0,0,0,.327-.269c.016-.015.034-.025.049-.04a2.4,2.4,0,0,0-.012-3.393l-.621-.617a2.553,2.553,0,0,1-.7-1.443,2.34,2.34,0,0,1,.329-1.492,18.409,18.409,0,0,0,1.1-2.079c.084-.186.167-.372.245-.56q.141-.345.27-.7",
    transform: "translate(-635.376 -264.356)",
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_187633",
    "data-name": "Group 187633",
    transform: "matrix(0.848, 0.53, -0.53, 0.848, -5021.822, 1186.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187632",
    "data-name": "Group 187632",
    transform: "translate(0 0)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187631",
    "data-name": "Group 187631",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38720",
    "data-name": "Path 38720",
    d: "M230.1,93.37h0L206.895,85.3Z",
    transform: "translate(-162.934 -46.325)",
    fill: "#c3e8e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38721",
    "data-name": "Path 38721",
    d: "M273.141,65.047v0l-3.6,10.351Z",
    transform: "translate(-194.341 -36.169)",
    fill: "#c3e8e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38722",
    "data-name": "Path 38722",
    d: "M128.134,14.022l-1.778,5.117,1.779-5.118h0",
    transform: "translate(-122.558 -10.59)",
    fill: "#c3e8e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38723",
    "data-name": "Path 38723",
    d: "M195.941,33.421l-26.36-9.16L131.8,11.131a2.9,2.9,0,0,0-3.687,1.785l-5.379,15.478a2.9,2.9,0,0,0,1.785,3.687l64.144,22.29a2.9,2.9,0,0,0,3.687-1.785l5.378-15.478a2.9,2.9,0,0,0-1.785-3.687m-67.744-4.2a1.73,1.73,0,1,1-1.066-2.2,1.73,1.73,0,0,1,1.066,2.2m2.272-6.537a1.73,1.73,0,1,1-1.067-2.2,1.73,1.73,0,0,1,1.067,2.2m.24-5.961a1.73,1.73,0,1,1,2.2-1.067,1.731,1.731,0,0,1-2.2,1.067m4.679,15a1.73,1.73,0,1,1-1.066-2.2,1.73,1.73,0,0,1,1.066,2.2m2.271-6.537a1.73,1.73,0,1,1-1.066-2.2,1.73,1.73,0,0,1,1.066,2.2m.24-5.961a1.73,1.73,0,1,1,2.2-1.066,1.73,1.73,0,0,1-2.2,1.066m4.434,14.912a1.73,1.73,0,1,1-1.066-2.2,1.73,1.73,0,0,1,1.066,2.2M144.6,27.6a1.73,1.73,0,1,1-1.066-2.2,1.729,1.729,0,0,1,1.066,2.2m.24-5.96a1.73,1.73,0,1,1,2.2-1.067,1.731,1.731,0,0,1-2.2,1.067m2.161,14.593h0l5.006-14.406,21.441,7.451-2.746,7.9-2.261,6.506Zm29.674,9.84a1.73,1.73,0,1,1-1.066-2.2,1.73,1.73,0,0,1,1.066,2.2m2.271-6.537a1.73,1.73,0,1,1-1.066-2.2,1.73,1.73,0,0,1,1.066,2.2m.24-5.961a1.73,1.73,0,1,1,2.2-1.066,1.729,1.729,0,0,1-2.2,1.066m4.679,15a1.73,1.73,0,1,1-1.066-2.2,1.73,1.73,0,0,1,1.066,2.2m2.272-6.537a1.73,1.73,0,1,1-1.067-2.2,1.731,1.731,0,0,1,1.067,2.2m.239-5.961a1.73,1.73,0,1,1,2.2-1.066,1.73,1.73,0,0,1-2.2,1.066m4.434,14.912a1.73,1.73,0,1,1-1.067-2.2,1.73,1.73,0,0,1,1.067,2.2m2.272-6.537a1.73,1.73,0,1,1-1.066-2.2,1.73,1.73,0,0,1,1.066,2.2m2.442-7.027a1.73,1.73,0,1,1-1.066-2.2,1.73,1.73,0,0,1,1.066,2.2",
    transform: "translate(-120.66 -9.059)",
    fill: "#dec8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38724",
    "data-name": "Path 38724",
    d: "M203.05,40.184l-21.441-7.451Z",
    transform: "translate(-150.258 -19.97)",
    fill: "#9ccacf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38725",
    "data-name": "Path 38725",
    d: "M193.011,69.073l-21.441-7.451,21.441,7.451,2.261-6.506Z",
    transform: "translate(-145.225 -34.453)",
    fill: "#9ccacf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154559",
    "data-name": "Rectangle 154559",
    width: 11.433,
    height: 18.88,
    transform: "translate(28.775 25.993) rotate(-70.839)",
    fill: "#df98c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38726",
    "data-name": "Path 38726",
    d: "M195.272,48.084l2.745-7.9-21.441-7.451h0L171.57,47.139h0l21.441,7.451ZM174,45.962l3.753-10.8,17.834,6.2-3.753,10.8Z",
    transform: "translate(-145.225 -19.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38727",
    "data-name": "Path 38727",
    d: "M237.145,51.843a1.73,1.73,0,1,0-2.2,1.066,1.73,1.73,0,0,0,2.2-1.066",
    transform: "translate(-176.412 -28.398)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38728",
    "data-name": "Path 38728",
    d: "M231.181,63.733a1.73,1.73,0,1,0,1.066,2.2,1.73,1.73,0,0,0-1.066-2.2",
    transform: "translate(-173.957 -35.463)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38729",
    "data-name": "Path 38729",
    d: "M226.626,76.841a1.73,1.73,0,1,0,1.066,2.2,1.73,1.73,0,0,0-1.066-2.2",
    transform: "translate(-171.673 -42.034)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38730",
    "data-name": "Path 38730",
    d: "M251.565,56.855a1.73,1.73,0,1,0-2.2,1.067,1.73,1.73,0,0,0,2.2-1.067",
    transform: "translate(-183.641 -30.911)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38731",
    "data-name": "Path 38731",
    d: "M245.6,68.743a1.73,1.73,0,1,0,1.066,2.2,1.73,1.73,0,0,0-1.066-2.2",
    transform: "translate(-181.186 -37.974)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38732",
    "data-name": "Path 38732",
    d: "M241.046,81.852a1.73,1.73,0,1,0,1.066,2.2,1.73,1.73,0,0,0-1.066-2.2",
    transform: "translate(-178.902 -44.546)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38733",
    "data-name": "Path 38733",
    d: "M264.425,59.492a1.73,1.73,0,1,0,1.066,2.2,1.73,1.73,0,0,0-1.066-2.2",
    transform: "translate(-190.623 -33.337)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38734",
    "data-name": "Path 38734",
    d: "M259.528,73.583a1.73,1.73,0,1,0,1.066,2.2,1.73,1.73,0,0,0-1.066-2.2",
    transform: "translate(-188.168 -40.401)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38735",
    "data-name": "Path 38735",
    d: "M254.973,86.692a1.73,1.73,0,1,0,1.066,2.2,1.73,1.73,0,0,0-1.066-2.2",
    transform: "translate(-185.884 -46.973)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38736",
    "data-name": "Path 38736",
    d: "M139.925,18.058a1.73,1.73,0,1,0-2.2,1.066,1.73,1.73,0,0,0,2.2-1.066",
    transform: "translate(-127.674 -11.461)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38737",
    "data-name": "Path 38737",
    d: "M133.961,29.948a1.73,1.73,0,1,0,1.066,2.2,1.73,1.73,0,0,0-1.066-2.2",
    transform: "translate(-125.219 -18.526)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38738",
    "data-name": "Path 38738",
    d: "M129.405,43.056a1.73,1.73,0,1,0,1.066,2.2,1.731,1.731,0,0,0-1.066-2.2",
    transform: "translate(-122.935 -25.097)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38739",
    "data-name": "Path 38739",
    d: "M154.343,23.07a1.73,1.73,0,1,0-2.2,1.066,1.729,1.729,0,0,0,2.2-1.066",
    transform: "translate(-134.902 -13.974)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38740",
    "data-name": "Path 38740",
    d: "M148.38,34.959a1.73,1.73,0,1,0,1.066,2.2,1.73,1.73,0,0,0-1.066-2.2",
    transform: "translate(-132.447 -21.038)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38741",
    "data-name": "Path 38741",
    d: "M143.825,48.067a1.73,1.73,0,1,0,1.066,2.2,1.73,1.73,0,0,0-1.066-2.2",
    transform: "translate(-130.164 -27.609)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38742",
    "data-name": "Path 38742",
    d: "M167.2,25.707a1.73,1.73,0,1,0,1.066,2.2,1.73,1.73,0,0,0-1.066-2.2",
    transform: "translate(-141.884 -16.4)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38743",
    "data-name": "Path 38743",
    d: "M162.307,39.8a1.73,1.73,0,1,0,1.066,2.2,1.73,1.73,0,0,0-1.066-2.2",
    transform: "translate(-139.429 -23.464)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38744",
    "data-name": "Path 38744",
    d: "M157.752,52.907a1.73,1.73,0,1,0,1.066,2.2,1.73,1.73,0,0,0-1.066-2.2",
    transform: "translate(-137.146 -30.036)",
    fill: "#a28aa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38745",
    "data-name": "Path 38745",
    d: "M197.4,32.143a4.789,4.789,0,0,0-2.748-2.446L130.5,7.407a4.806,4.806,0,0,0-6.117,2.962l-.07.2-1.779,5.118-3.53,10.158a4.807,4.807,0,0,0,2.962,6.117L162.7,46.119l23.211,8.066.2.07a4.806,4.806,0,0,0,6.118-2.962l1.711-4.925,3.6-10.351.07-.2a4.789,4.789,0,0,0-.214-3.672m-1.59,3.045-5.378,15.478a2.9,2.9,0,0,1-3.687,1.785L122.6,30.161a2.9,2.9,0,0,1-1.785-3.687L126.191,11a2.9,2.9,0,0,1,3.687-1.785L194.022,31.5a2.9,2.9,0,0,1,1.785,3.687",
    transform: "translate(-118.741 -7.14)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_187588",
    "data-name": "Group 187588",
    transform: "translate(-5040.943 1197.875) rotate(67)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187587",
    "data-name": "Group 187587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187586",
    "data-name": "Group 187586",
    clipPath: "url(#clip-path-3)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38135",
    "data-name": "Path 38135",
    d: "M316.725,236.825l-5.4-16.36-7.172-21.739,13.98,42.376h0Z",
    transform: "translate(-299.272 -165.676)",
    fill: "#85b9c9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38136",
    "data-name": "Path 38136",
    d: "M391.813,216.793l-13.98-42.376h0l13.981,42.378v0",
    transform: "translate(-335.484 -153.727)",
    fill: "#85b9c9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38137",
    "data-name": "Path 38137",
    d: "M324.849,229.078l28.829-9.511a2.731,2.731,0,0,0,1.736-3.445l-14.318-43.4a2.731,2.731,0,0,0-3.445-1.736l-28.83,9.511a2.731,2.731,0,0,0-1.735,3.446l1.58,4.788L334,180.374,345.154,214.2l-25.33,8.357,1.58,4.788a2.731,2.731,0,0,0,3.445,1.736",
    transform: "translate(-300.644 -151.974)",
    fill: "#703289"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38138",
    "data-name": "Path 38138",
    d: "M312.3,172.633l24.456-8.069-1.545-4.683L322.7,164.01l-11.939,3.939Z",
    transform: "translate(-302.517 -146.583)",
    fill: "#fff7fb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38139",
    "data-name": "Path 38139",
    d: "M314.731,151.156l16.549-5.46-3.948-11.968L294.55,144.544l3.948,11.968,4.293-1.416Z",
    transform: "translate(-294.551 -133.729)",
    fill: "#481851"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38140",
    "data-name": "Path 38140",
    d: "M323.657,257.839l-5.4-16.36Z",
    transform: "translate(-306.204 -186.689)",
    fill: "#c8dfe5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38141",
    "data-name": "Path 38141",
    d: "M335.657,189.582l-25.331,8.357,11.158,33.822,25.331-8.357Zm-8,30.346-1.767-5.356-5.356,1.767-1.794-5.437,5.356-1.767-1.767-5.356,5.437-1.793,1.767,5.356,5.356-1.767,1.793,5.436-5.356,1.768,1.767,5.356Z",
    transform: "translate(-302.305 -161.181)",
    fill: "#fff0f9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38142",
    "data-name": "Path 38142",
    d: "M344.807,223l-1.793-5.437-5.356,1.768-1.767-5.356-5.436,1.793,1.767,5.356-5.356,1.767,1.793,5.437,5.356-1.767,1.768,5.356,5.436-1.794-1.767-5.356Z",
    transform: "translate(-310.433 -173.17)",
    fill: "#c0348a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38143",
    "data-name": "Path 38143",
    d: "M355.383,213.792l-.168-.51L341.233,170.9l-.168-.51a4.546,4.546,0,0,0-5.742-2.893l-28.829,9.511a4.546,4.546,0,0,0-2.893,5.741l.169.512L310.942,205l5.4,16.36,1.411,4.277.169.511a4.546,4.546,0,0,0,5.742,2.893l28.829-9.511a4.546,4.546,0,0,0,2.893-5.742m-48.475-26.82-1.58-4.788a2.73,2.73,0,0,1,1.736-3.445l28.829-9.511a2.73,2.73,0,0,1,3.445,1.736l14.318,43.4a2.731,2.731,0,0,1-1.736,3.445l-28.829,9.511a2.731,2.731,0,0,1-3.445-1.736l-1.58-4.788Z",
    transform: "translate(-298.886 -150.215)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelineBackground1);
export default __webpack_public_path__ + "static/media/guideline-background-1.9137d15b1f72d96a7d4e385b5d7a8429.svg";
export { ForwardRef as ReactComponent };